export const MAX_PRODUCTS_USER_SORT = 1000;
export const BOOST_PRODUCTS_USER_SORT = 3000;
